import { render, staticRenderFns } from "./BusinessType.vue?vue&type=template&id=21bcbc9b&scoped=true"
import script from "./BusinessType.vue?vue&type=script&lang=js"
export * from "./BusinessType.vue?vue&type=script&lang=js"
import style0 from "./BusinessType.vue?vue&type=style&index=0&id=21bcbc9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bcbc9b",
  null
  
)

export default component.exports